<template>
  <div style="height:100%;width:100%">
    <div class="col-12 p-0" style="border-bottom: 1px solid #0000001f;text-align: center;">
      <span style="color: var(--color-primary);font-weight: bold;" v-if="selectedDay && today"><span v-if="today.valueOf() == selectedDay.date.valueOf()">{{$t('message.Today')}}, </span>{{selectedDay.date.toLocaleString('default', { month: 'short' })}} {{selectedDay.date.toLocaleString('default', { day:"numeric" })}} {{selectedDay.date.toLocaleString('default', {  year: 'numeric', })}}</span>
      <div class="d-flex" style="justify-content: space-around" v-if="selectedDay && today">
        <div class=" text-center">
          <n-button type="primary" round icon :disabled="currentWeek" simple style="border: none" @click.native="goToPrevWeek">
            <i class="fa fa-chevron-left"></i>
          </n-button>
        </div>

        <div class="text-center" style="white-space: nowrap; overflow: scroll" ref="day-selector">
          <n-button type="primary" :disabled="currentWeek && day.date.getTime() < today.getTime()" round icon :id="day.date.getTime()" v-for="day in days" :key="day.date.getTime()" @click.native="selectDay(day)" :simple="selectedDay != day">
            {{ day.formattedDate }}
          </n-button>
        </div>

        <div class="text-center">
          <n-button type="primary" round icon simple style="border: none" @click.native="goToNextWeek">
            <i class="fa fa-chevron-right"></i>
          </n-button>
        </div>
      </div>
    </div>

    <div class="col-12" style="text-align: center;padding: 0px;" id="reminders">
      <h5 style="padding-top: 1em;" v-if="selectedDaysReminders('morning').length == 0 && selectedDaysReminders('afternoon').length == 0 && selectedDaysReminders('evening').length == 0 && selectedDaysReminders('night').length == 0">{{ $t("message.No reminders for this day") }}</h5>
      <div v-else style="margin-top: 1em;height: 73vh;overflow: scroll;">
        <card style="width: 95%;margin: 0.7em;text-align: left;" class="rounded" v-if="selectedDaysReminders('morning').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-left: 0.5em;color: black;font-size: 1.2em;">Morning</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in selectedDaysReminders('morning')" :key="reminder.id" class="col-12" style="padding: 0px;display: flex;align-items: center;" :style="selectedDaysReminders('morning').length > 0  && index < selectedDaysReminders('morning').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-right: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-left: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-10" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
          </div>
        </card>

        <card style="width: 95%;margin: 0.7em;text-align: left;" class="rounded" v-if="selectedDaysReminders('afternoon').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-left: 0.5em;color: black;font-size: 1.2em;">Afternoon</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in selectedDaysReminders('afternoon')" :key="reminder.id" class="col-12;" style="padding: 0px;display: flex;align-items: center;" :style="selectedDaysReminders('afternoon').length > 0  && index < selectedDaysReminders('afternoon').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-right: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-left: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-10" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
          </div>
        </card>

        <card style="width: 95%;margin: 0.7em;text-align: left;" class="rounded" v-if="selectedDaysReminders('evening').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-left: 0.5em;color: black;font-size: 1.2em;">Evening</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in selectedDaysReminders('evening')" :key="reminder.id" class="col-12;" style="padding: 0px;display: flex;align-items: center;" :style="selectedDaysReminders('evening').length > 0  && index < selectedDaysReminders('evening').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-right: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-left: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-10" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>

          </div>
        </card>

        <card style="width: 95%;margin: 0.7em;text-align: left;" class="rounded" v-if="selectedDaysReminders('night').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-left: 0.5em;color: black;font-size: 1.2em;">Night</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in selectedDaysReminders('night')" :key="reminder.id" class="col-12;" style="padding: 0px;display: flex;align-items: center;" :style="selectedDaysReminders('night').length > 0  && index < selectedDaysReminders('night').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-right: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-left: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-10" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="col-12" style="position: fixed;bottom: 1em;display: flex;justify-content: center;align-items: center;">
      <n-button simple type="primary" round v-if="this.scheduledReminders && this.scheduledReminders.length > 0" size="sm" style="margin-right: 1em;padding: 4px 15px;" @click.native="resetReminders">
        <i class="fas fa-sync-alt"></i>
        {{ $t("message.Reset Reminders") }}
      </n-button>

      <n-button type="primary" size="sm" round @click.native="$router.push('prescriptionforreminders')">
        <i class="fa fa-plus"></i>
        {{ $t("message.Add Reminders") }}
      </n-button>
    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      days: [],
      selectedDay: null,
      today: null,
      scheduledReminders: [],
    };
  },
  beforeDestroy() {
    cordova.plugins.notification.local.un("trigger", this.getReminders, this);
  },
  async mounted() {
    let curr = new Date();
    curr.setHours(0, 0, 0, 0);
    this.today = curr;

    for (let i = 0; i < 7; i++) {
      let first = curr.getDate() - curr.getDay() + i;
      let day = new Date(curr.setDate(first));
      this.days.push({
        date: day,
        formattedDate: moment(day).format("dd").charAt(0),
      });
    }

    curr = new Date();
    curr.setHours(0, 0, 0, 0);
    this.today = curr;

    for (let day of this.days) {
      if (day.date.valueOf() == this.today.valueOf()) {
        this.selectDay(day);
        break;
      }
    }
    cordova.plugins.notification.local.on("trigger", this.getReminders, this);
    this.getReminders();
  },
  methods: {
    selectDay(day) {
      this.selectedDay = day;
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    getReminders() {
      cordova.plugins.notification.local.getScheduled((res) => {
        this.scheduledReminders = res.filter(
          (obj) =>
            obj.data.normalize().replace(/"/g, "") == "medication notification"
        );
      });
    },
    resetReminders() {
      swal
        .fire({
          title:
            "Are you sure that you want to remove all medication reminders?",
          confirmButtonText: "yes",
          showCancelButton: true,
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result && result.value) {
            let that = this;
            cordova.plugins.notification.local.getScheduled((res) => {
              for (let notification of res) {
                if (
                  notification.data.normalize().replace(/"/g, "") ==
                  "medication notification"
                ) {
                  cordova.plugins.notification.local.cancel(
                    notification.id,
                    (res) => {
                      console.log(res);
                    }
                  );
                }
              }
              swal.fire({
                title: "All reminders are removed!",
                type: "success",
              });
              that.getReminders();
            });
          }
        });
    },
    getClassName(text) {
      try {
        if (text.split(",")[1].includes("TABLET")) {
          return "fa-tablets";
        } else if (text.split(",")[1].includes("CAPSULE")) {
          return "fa-capsules";
        } else if (text.split(",")[1].includes("INJECTION")) {
          return "fa-syringe";
        } else if (text.split(",")[1].includes("SOLUTION")) {
          return "fa-flask";
        } else if (text.split(",")[1].includes("POWDER")) {
          return "fa-prescription-bottle";
        } else if (text.split(",")[1].includes("SYRUP")) {
          return "fa-fill-drip";
        } else if (text.split(",")[1].includes("PILL")) {
          return "fa-pills";
        } else if (text.split(",")[1].includes("LOTION")) {
          return "fa-tint";
        } else if (text.split(",")[1].includes("GEL")) {
          return "fa-tint";
        } else if (text.split(",")[1].includes("CREAM")) {
          return "fa-tint";
        } else if (text.split(",")[1].includes("DROPS")) {
          return "fa-eye-dropper";
        } else {
          return "fa-prescription-bottle-alt";
        }
      } catch {
        return "fa-prescription-bottle-alt";
      }
    },
    goToNextWeek() {
      let curr = this.days[6].date;

      curr.setDate(curr.getDate() + 1);

      this.days = [];

      for (let i = 0; i < 7; i++) {
        let first = curr.getDate() - curr.getDay() + i;
        let day = new Date(curr.setDate(first));
        this.days.push({
          date: day,
          formattedDate: moment(day).format("dd").charAt(0),
        });
      }

      this.selectDay(this.days[this.selectedDay.date.getDay()]);
    },
    goToPrevWeek() {
      let selectSunday = false;
      if (this.selectedDay.date.getDay() == 0) {
        selectSunday = true;
      }
      let curr = this.days[0].date;

      curr.setDate(curr.getDate() - 1);

      this.days = [];

      for (let i = 0; i < 7; i++) {
        let first = curr.getDate() - curr.getDay() + i;
        let day = new Date(curr.setDate(first));
        this.days.push({
          date: day,
          formattedDate: moment(day).format("dd").charAt(0),
        });
      }

      if (selectSunday) {
        this.selectedDay = this.days[0];
      } else {
        this.selectedDay = this.days[this.selectedDay.date.getDay()];
      }

      if (
        this.currentWeek &&
        this.selectedDay.date.getTime() < this.today.getTime()
      ) {
        for (let day of this.days) {
          if (day.date.valueOf() == this.today.valueOf()) {
            this.selectDay(day);
            break;
          }
        }
      }
    },
    selectedDaysReminders(time) {
      if (
        this.scheduledReminders &&
        this.scheduledReminders.length > 0 &&
        this.selectedDay
      ) {
        let that = this;
        let selectedDaysReminders = this.scheduledReminders.filter(function (
          reminder
        ) {
          return (
            new Date(reminder.trigger.at).setHours(0, 0, 0, 0) ==
              that.selectedDay.date.valueOf() &&
            reminder.title.split(" ")[0].toLowerCase() == time
          );
        });
        return selectedDaysReminders;
      }
      return [];
    },
  },
  computed: {
    currentWeek() {
      if (this.today) {
        for (let day of this.days) {
          if (day.date.valueOf() == this.today.valueOf()) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
/deep/ #reminders .card-body {
  padding: 15px;
}
</style>
